<template>
  <div class="tab-text" id="withdraw_form_crypto">

    <vs-alert class="my-3" color="warning" :active="coin.network.length <= 0" icon-pack="feather" icon="icon-alert-circle">
      {{$t('There is no possibility of deposit and withdrawal in increasing and decreasing currencies!')}}
    </vs-alert>
    <div v-if="coin.network.length > 0">
      <p>جهت برداشت از موجودی میتوانید فرم زیر را تکمیل نمایید و سپس وجه مورد نظر شما به آدرس کیف پولی که درج کرده اید منتقل میشود.</p>
      <div class="text-center mt-base">
        <i class="font-large-5 cf" v-if="isFontExist(coin.symbol)" :class="'cf-'+coin.symbol.toLowerCase()" :style="{color:colorSymbol(coin.symbol)}"></i>
        <img :src="publicPath+'images/currency/' + iconSymbol(coin.symbol)" class="mx-auto lg:w-1/12 w-1/3" v-else/>
      </div>
      <form autocomplete="off" v-on:submit.prevent="submitFormWithdraw()">
        <div class="lg:w-3/5 mx-auto">
          <div class="vx-row mb-8">
            <div class="vx-col w-full">
              <vs-input class="w-full" icon-pack="feather" size="large" icon-no-border icon="icon-activity" label="مبلغ برداشت" v-model="withdrawAmount"
                        v-validate="'required'" :class="errors.has('withdrawAmount') && withdrawSubmit ? 'border-danger':'' " name="withdrawAmount"/>
              <p class="mt-2">
                {{$t('Your withdrawable balance')}}:
                <span class="text-warning cursor-pointer border-b border-solid border-l-0 border-r-0 border-t-0" @click="withdrawAmount=toFixFloat(coin.balance_available);onClickCopy=true">
                  <i class="feather icon-hash"></i>{{toFixFloat(coin.balance_available)}}
                </span>
              </p>
              <p>
                مقدار برداشت روزانه معادل:
                {{ parseFloat(dailyWithdrawalCrypto).toLocaleString('en-US') }}
                از
                {{parseFloat(levelInfo.dailyWithdrawalCrypto).toLocaleString('en-US')}} {{$t('Toman')}}
              </p>
              <transition name="slide">
                <p v-if="withdrawAmount && removeLocalString(withdrawAmount)>0 && removeLocalString(withdrawAmount) - network.withdraw_fee >0">
                  دریافتی خالص با کسر کارمزد:
                  <span class="text-primary">{{toFixFloat(+(removeLocalString(withdrawAmount) - network.withdraw_fee).toFixed(coin.percent))}} {{coin.symbol}}</span>
                </p>
              </transition>
            </div>
          </div>

          <div class="vx-row mb-8">
            <div class="vx-col w-full mb-8">
              <vs-input class="w-full" icon-pack="feather" size="large" icon-no-border icon="icon-slack" :label="$t('Destination wallet address')" v-model="withdrawAddressWallet"
                        v-validate="'required'" :class="errors.has('withdrawAddressWallet') && withdrawSubmit ? 'border-danger':'' " name="withdrawAddressWallet"/>
              <p class="mt-2">نکته مهم: با درج کردن آدرس اشتباه ممکن است باعث از دست رفتن منابع مالی شما شود.</p>
            </div>

            <div class="vx-col w-full mb-8" v-if="network.tag">
              <vs-input class="w-full" icon-pack="feather" size="large" icon-no-border icon="icon-hash" :label="$t('Address tag/memo')"
                        :class="errors.has('withdrawAddressWalletTag') && withdrawSubmit ? 'border-danger':'' "
                        v-model="withdrawAddressWalletTag" name="withdrawAddressWalletTag"/>
            </div>



            <div class="vx-col w-full mb-8">
              <vs-select class="w-full" name="gateway" v-validate="'required'" v-model="network" label="شبکه انتقال" size="large" >
                <vs-select-item :key="index" :value="item" :text="item.locale[islocale]['name']+' - '+item.name" v-for="(item,index) in coin.network" />
              </vs-select>
            </div>

            <div class="vx-col w-full mb-8">
              <vs-input class="w-full" icon-pack="feather" readonly color="warning" size="large" icon-no-border icon="icon-grid" label="کارمزد انتقال"
                        :value="network.withdraw_fee+' '+getNameCoin(coin.symbol)[islocale]"/>
              <div class="mt-2" v-if="Object.keys(coin.network).length >= 1">
                <p v-for="(item,index) in coin.network">
                  {{$t('transfer fee in')}}
                  {{$t('network')}} {{item.locale[islocale]['name']}}: {{ item.withdraw_fee }}
                  {{ getNameCoin(coin.symbol)[islocale]}}
                </p>
                <vs-divider/>
              </div>
              <p class="my-2">کارمزد انتقال مربوط به ثبت تراکنش در شبکه‌ی
                {{ network.symbol!=null ? network.locale[islocale]['name'] : getNameCoin(coin.symbol)[islocale]}}
                بوده و  {{$t(appName)}} در آن ذینفع نیست.
              </p>
              <p>
                در صورتی که آدرس مقصد متعلق به کاربران {{$t(appName)}} بوده و توسط {{$t(appName)}} مدیریت شود، انتقال به صورت مستقیم و سریع صورت می‌گیرد و کارمزد انتقال صفر خواهد بود.
              </p>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full flex">
              <vs-button class="lg:mr-3 lg:mx-0 mx-auto mb-2" icon-pack="feather" icon="icon-check" :disabled="isLoading"
                         :id="'button-withdraw-'+ coin.name" @click.prevent="submitFormWithdraw">
                ثبت درخواست برداشت
              </vs-button>
              <vs-button color="dark" type="border" class="mb-2 hidden lg:inline-block" :to="'/wallets'">بازگشت</vs-button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <vs-divider/>
    <div class="mt-5 flex flex-wrap">
      <p class="mt-3">اگر نیاز به کمک دارید فیلم آموزش این بخش را مشاهده کنید.
      </p>
      <vs-button color="warning" :href="videoLearn.withdraw" target="_blank" class="mx-2" type="border"  icon-pack="feather" icon="icon-play">فیلم آموزش</vs-button>
    </div>

  </div>
</template>

<i18n locale="fa">
{
  "The amount of withdrawals is more than the amount of inventory available to you.":"مقدار برداشت از مقدار موجودی قابل برداشت شما بیشتر است."
  ,"minWithdraw":"حداقل مقدار برداشت {amount} {symbol} است."
  ,"Destination wallet address":"آدرس کیف پول مقصد"
  ,"tag":"تگ"
  ,"Wallet address is wrong!":"آدرس کیف پول اشتباه است!"
  ,"Address tag/memo":"تگ/ممو آدرس"
  ,"Wallet address tag/memo is wrong!":"تگ/ممو آدرس کیف پول اشتباه است."
  ,"Withdrawal confirmation code":"کد تایید برداشت"
  ,"Your withdrawable balance":"موجودی قابل برداشت شما"
  ,"There is no possibility of deposit and withdrawal in increasing and decreasing currencies!":"در ارزهای افزایشی و کاهشی امکان واریز و برداشت وجود ندارد!"
}
</i18n>
<i18n locale="en">
{
  "minWithdraw": "The minimum withdrawal amount is {amount} {symbol}."
}
</i18n>
<script>
    import axios from "../../../http/axios";

    export default {
      props: ['coin','dailyWithdrawalCrypto','levelInfo'],
      name: "Withdraw",
      data () {
        return {
          withdrawAddressWallet: '',
          withdrawAddressWalletTag: '',
          withdrawAmount: '',
          codeOtp: null,

          network: null,
          defaultNetwork: null,
          withdrawSubmit: false,
          isLoading:false,
          onClickCopy: false,
        }
      },
      methods:{
        submitFormWithdraw(){
          this.$validator.validateAll().then(result => {
            if (result) {
              var withdrawAmount = this.withdrawAmount.replace(/[^\d.-]/g, '');
              if(! this.withdrawAddressWallet.match(this.network.addressRegex) ){
                this.$swal(this.$t('Warning'), this.$t('Wallet address is wrong!') ,'warning')
                return;
              }
              if(this.network.tag && this.withdrawAddressWalletTag!="" && !this.withdrawAddressWalletTag.match(this.network.memoRegex) ){
                this.$swal(this.$t('Warning'), this.$t('Wallet address tag/memo is wrong!') ,'warning')
                return;
              }

              if(withdrawAmount > this.coin.balance_available){
                this.$swal(this.$t('Warning'), this.$t('The amount of withdrawals is more than the amount of inventory available to you.') ,'warning')
                return;
              }

              if(withdrawAmount < this.network.withdraw_min){
                this.$swal(this.$t('Warning'), this.$t('minWithdraw',{amount:this.network.withdraw_min,symbol:this.coin.symbol}) ,'warning')
                return;
              }
              this.isLoading = true;

              this.$vs.loading({
                container: '#button-withdraw-'+this.coin.name,
                scale: 0.65
              })
              const self = this
              axios.post('/wallets/'+ this.coin.name +'/withdraw',
            {
                  network: this.network.symbol,codeOtp:this.codeOtp, withdrawAmount:withdrawAmount,
                  withdrawAddressWallet:this.withdrawAddressWallet ,withdrawAddressWalletTag:this.withdrawAddressWalletTag
                })
                .then(function (response) {
                  if (response.data.status == true) {
                    self.updateUser();
                    self.$emit('refreshData');
                    self.withdrawAddressWallet = '';
                    self.withdrawAmount = '';
                    self.withdrawSubmit = false;
                    self.$swal(self.$t('Success'), response.data.msg ,'success');
                  }else if(response.data.otp == true) {
                    self.otp(response);
                  }else {
                    self.$vs.notify({title: self.$t('Error'),text: response.data.msg ,iconPack: 'feather',icon: 'icon-alert-circle',color: 'danger',time:6000})
                  }
                  self.$vs.loading.close('#button-withdraw-'+self.coin+' > .con-vs-loading');
                  self.isLoading = false;
                }).catch(function (error) { self.$vs.loading.close('#button-withdraw-'+self.coin.name+' > .con-vs-loading'); self.isLoading = false; })
            } else {
              this.withdrawSubmit = true
            }
          })
        },
        otp(response){
         this.$swal({
            icon: 'question',
            title: this.$t('Withdrawal confirmation code'),
            input: 'text',
            inputLabel: (response.data.msgOtp?response.data.msgOtp:response.data.msg),
            showCancelButton: true,
            inputValidator: (value) => {
              if (!value) {
                return this.$t('You must enter the code!')
              }
            },
            preConfirm: (value) => {
              this.codeOtp = value;
              this.submitFormWithdraw();
            },
          })
        }
      },
      watch:{
        withdrawAmount (value) {
            if(!this.onClickCopy){
              this.withdrawAmount = this.amountLocalFloat(value, 8)
            }else
              this.onClickCopy = false;
        },
        withdrawAddressWallet(newValue){
          if(newValue.length > 0){
            for (var i = 0; i < Object.keys(this.coin.network).length; i++) {
              var selector = newValue.substring(0, this.coin.network[i].selector.length);
              if(this.coin.network[i].selector == selector){
                this.network = this.coin.network[i];
                break;
              }else
                this.network = this.defaultNetwork
            }
          }else
            this.network = this.defaultNetwork
        }
      },
      computed:{

      },
      created() {
        this.defaultNetwork = this.coin.network.find(o => o.is_default ===true);
        this.network = this.coin.network.find(o => o.is_default ===true);
      }
    }
</script>

<style lang="scss">
  #withdraw_form_crypto {

    .input-select.vs-select--input{
      padding: 1.1rem 1rem 1rem !important;
    }
  }
</style>
